var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.applyList),function(item){return _c('mt-cell',{key:item.id,attrs:{"title":item.user_name + ' ' + item.user_code,"label":item.apply_date}},[_c('mt-button',{attrs:{"type":"primary","plain":"","size":"small"},nativeOn:{"click":function($event){_vm.untie(item.id)}}},[_vm._v("解除绑定")])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-637b3758","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ApplyUntie.vue
// module id = null
// module chunks = 